import React, { useState, useEffect } from "react";
import SachivProfile from "./SachivProfile";
import SarpanchDetails from "./SarpanchDetails";
import OtherDeatils from "./OtherDeatils";
import LineDepartmentProfile from "./LineDepartmentProfile";

const Profile = () => {
  const [type, setType] = useState("sachiv");
  const user_id = sessionStorage.getItem("user_id");
  const token = sessionStorage.getItem("token");
  const [sachivDetails, setSachivDetails] = useState([]);

  const switchButton = (type) => {
    if (type == "sachiv") {
      setType("sachiv");
    }
    if (type == "sarpanch") {
      setType("sarpanch");
    }
    if (type == "other") {
      setType("other");
    }
  };

  return (
    <>
      {user_id == 2 ? (
        <div
          className="container-fluid"
          style={{ background: "#fff", overflowX: "hidden" }}
        >
          <div className="d-flex justify-content-center align-items-center gap-4 pt-2">
            <div className="d-flex">
              <button
                className={
                  type === "sachiv"
                    ? "btn btn-outline-primary"
                    : "btn btn-outline-secondary"
                }
                onClick={(e) => switchButton("sachiv")}
                style={{
                  backgroundColor: type === "sachiv" ? "#4763E4" : "#4763E430",
                  color: type === "sachiv" ? "#fff" : "#4763E4",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  margin: "0 10px",
                }}
                onMouseOver={(e) => {
                  if (type !== "sachiv") {
                    e.target.style.backgroundColor = "#4763E4";
                    e.target.style.color = "#fff";
                  }
                }}
                onMouseOut={(e) => {
                  if (type !== "sachiv") {
                    e.target.style.backgroundColor = "#4763E430";
                    e.target.style.color = "#4763E4";
                  }
                }}
              >
                Gram Sachiv Details
              </button>

              <button
                className={
                  type === "sarpanch"
                    ? "btn btn-outline-primary"
                    : "btn btn-outline-secondary"
                }
                onClick={(e) => switchButton("sarpanch")}
                style={{
                  backgroundColor: type === "sarpanch" ? "#4763E4" : "#4763E430",
                  color: type === "sarpanch" ? "#fff" : "#4763E4",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  margin: "0 10px",
                }}
                onMouseOver={(e) => {
                  if (type !== "sarpanch") {
                    e.target.style.backgroundColor = "#4763E4";
                    e.target.style.color = "#fff";
                  }
                }}
                onMouseOut={(e) => {
                  if (type !== "sarpanch") {
                    e.target.style.backgroundColor = "#4763E430";
                    e.target.style.color = "#4763E4";
                  }
                }}
              >
                Sarpanch Details
              </button>

              <button
                className={
                  type === "other"
                    ? "btn btn-outline-primary"
                    : "btn btn-outline-secondary"
                }
                onClick={(e) => switchButton("other")}
                style={{
                  backgroundColor: type === "other" ? "#4763E4" : "#4763E430",
                  color: type === "other" ? "#fff" : "#4763E4",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  margin: "0 10px",
                }}
                onMouseOver={(e) => {
                  if (type !== "other") {
                    e.target.style.backgroundColor = "#4763E4";
                    e.target.style.color = "#fff";
                  }
                }}
                onMouseOut={(e) => {
                  if (type !== "other") {
                    e.target.style.backgroundColor = "#4763E430";
                    e.target.style.color = "#4763E4";
                  }
                }}
              >
                Other Details
              </button>
            </div>
          </div>
          {type == "sachiv" ? (
            <SachivProfile />
          ) : type == "sarpanch" ? (
            <SarpanchDetails />
          ) : type == "other" ? (
            <OtherDeatils />
          ) : null}
        </div>
      ) : (
        <div
          className="container-fluid"
          style={{ background: "#fff", overflowX: "hidden" }}
        >
          <LineDepartmentProfile />
        </div>)}
    </>
  );
};
export default Profile;
